module.exports = __webpack_public_path__ + "static/media/studio-slide11.dfe912f6.png";